import React from "react";
import Card from "./card";

interface Props {
  products?: any[];
}

export default function CardList(props: Props) {
  const products = props.products;

  return (
    <>
      <div className="product-list md:overscroll-none overflow-y-scroll scrollbar-hide">
        {products?.map((product, i) => (
          <Card key={i} product={product?.node} handleOnClick={true} />
        ))}
        {/* Do not delete the line below. It's there so that the products are displayed well*/}
        <div className="product-list-item"></div>
      </div>
    </>
  );
}
